<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li>
      <a>{{ company_name }}:</a>
    </li>
    <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ tabActice=='tab-3'?'Energy Meters':item.page_title }}
      </a>
    </li>
  </ul>
  <div class="right">
    <span>{{ today }}</span>
  </div>
</div>
<div class="tag_powered_by">
  <span>Powered by: <b>Enertics</b></span>
</div>

<div class="Content_outer">
  <div class="tab_right" *ngIf="legendKey">
    <div class="legendbox legendBoxTop">
      <button *ngIf="hideaddsubsystem" mat-raised-button color="primary" (click)="DefineAssets()">
        <span class="sprite_icon plus_white"></span>
        <span><b>Add Sub-System</b></span>
      </button>
      <div style="background-color: #cecece"></div>
      <strong>Asset Idle</strong>
      <div style="background-color: #3fbddd"></div>
      <strong>Asset Running</strong>
      <div style="background-color: #999999"></div>
      <strong>Offline</strong>
      <div style="background-color: #72ff13"></div>
      <strong>Healthy</strong>
      <div style="background-color: #faa700"></div>
      <strong>Unsatisfactory</strong>
      <div style="background-color: #fcda42"></div>
      <strong>Out for service</strong>
    </div>
  </div>

  <ul ngbNav
  style="
          position: fixed;
          width: 100%;
          background-color: #f7f7f7;
          z-index: 500;
          top:97px;
        "
  #ctdTabset="ngbNav"
  class="nav nav-tabs custom_tab"
  [(activeId)]="tabActice" (navChange)="onTabChange($event)">
    <li [ngbNavItem]="'tab-1'" *ngIf="tabID_1">
      <a ngbNavLink>Rotating Assets <span>({{totalNumberRotatingDevice}})</span></a>
      <ng-template ngbNavContent>
        <mat-toolbar class="top_headerbar">
          <div class="left" [ngClass]="{ show: shouldShow, hide: !shouldShow }">
            <span *ngIf="hideItemsFromAssets" class="custom_select_outer">
              <select class="custom_select form-control width_180" #mySelect (change)="onSiteSelected(mySelect.value)"
                *ngIf="!showFilter">
                <option value="0">All Sites</option>
                <option value="{{ site.id }}" *ngFor="let site of sitesList">
                  {{ site.name }}
                </option>
              </select>
            </span>
            <span *ngIf="hideItemsFromAssets" class="custom_select_outer">
              <select class="custom_select form-control width_180" #groupSelect
                (change)="onGroupSelected(groupSelect.value)" *ngIf="!showFilter">
                <option value="0">All Applications</option>
                <option value="{{ group.id }}" *ngFor="let group of groupList; let idx = index">
                  {{ group.name }}
                </option>
              </select>
            </span>
            <span class="custom_select_outer">
              <select class="custom_select form-control width_180" [value]="assetsFilter" #assetsSelect
                (change)="viewAssetsList(assetsSelect.value)">
                <option value="ALL">All Assets</option>
                <option value="OFFLINE">Offline</option>
                <option value="HEALTHY">Healthy</option>
                <option value="UNHEALTHY">Unsatisfactory</option>
                <option value="ERROR">Unacceptable</option>
                <option value="OUTOFSERVICE">Out for Service</option>
              </select>
            </span>
          </div>

         <div style="display: flex;width: 100%;justify-content: end;">
          <!-- <div class="opwertrainToggle" *ngIf=" (production && (userID==390 || userID==4 || userID==459 || userID==258 )) || !production "> -->
          <div class="opwertrainToggle" *ngIf="isPowertrainEnabled">
            Assets<mat-slide-toggle [(ngModel)]="showPowertrain" color="primary"  (change)="onPowertrainToggleChange($event)">Powertrain</mat-slide-toggle> &nbsp;
        </div>
        <div class="dragDrop" *ngIf="!showPowertrain && totalSize > 1">
          <button mat-raised-button color="primary" (click)="stopUserAssetsApi()">
            Rearrange
          </button>
          <button mat-stroked-button color="accent" (click)="saveAssetsIndex()">Save</button>
        </div>
        <div class="dragDrop" *ngIf="showPowertrain && role !== 'ADMIN' && totalSize > 1">
          <button mat-raised-button color="primary" (click)="stopUserAssetsApi()">
            Rearrange
          </button>
          <button mat-stroked-button color="accent" (click)="savePowertrainIndex()">Save</button>
        </div>
        <div *ngIf="adminClinetLogin" class="right">
          <div *ngIf="hideItemsFromAssets" class="all_action_btns">
            <div class="custom_search width_200" *ngIf="!showPowertrain">
              <span class="sprite_icon search"></span>
              <input type="text" class="form-control" placeholder="Serial Number" [(ngModel)]="term"
                (input)="searchData($event.target.value)" />
            </div>
            <div class="custom_search width_200" *ngIf="showPowertrain">
              <span class="sprite_icon search"></span>
              <input type="text" class="form-control" placeholder="Serial Number" [(ngModel)]="term"
                (input)="searchPowerTrainData($event.target.value)" />
            </div>
            <!-- <div class="filter_toggle" (click)="shouldShow = !shouldShow">
                <span class="sprite_icon flask_grey"></span>
              </div> -->

            <div class="btn-group view_btn_group">
              <button type="button" class="btn default_btn" (click)="listLayout()">
                <span class="sprite_icon grid_grey" [ngClass]="{ grid_blue: gridLayoutOn }"></span>
              </button>
              <button type="button" class="btn default_btn" (click)="gridLayout()">
                <span [ngClass]="{ list_blue: listLayoutOn }" class="sprite_icon list_grey"></span>
              </button>
            </div>
            <!-- <button [disabled]="disablePlantButton" class="default_btn buttonColor" mat-raised-button (click)="checkPlantDashboard()">
                <span>View Plant Dashboard</span>
              </button> -->

          </div>
        </div>
         </div>



        </mat-toolbar>
        <div class="powertrains-container" *ngIf="showPowertrain">
          <!-- POWERTRAIN LOADER -->
          <ng-template #showLoader>
            <!-- POWERTRAIN LOADER -->
            <div
              class="d-flex align-items-center justify-content-center w-100 mt-4"
              style="height: 60vh;"
            >
              <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
            </div>
          </ng-template>

          <!-- POWERTRAIN WORKING FOR NOW -->
          <div class="pt_container_filtered">
            <div class="powertrain-card" cdkDrag *ngFor="let powertrain of filteredPowertrainList;let i = index" [ngStyle]="{'background-color':powertrain.overall_health}" [class.redBlink]="powertrain.overall_health=='#f8d7da'">
              <div class="title">{{powertrain.subsystem_name}}</div>
              <div class="status-symbol">
                <span
                *ngIf="[0,2].includes(powertrain.overall_live_status)"
                class="seen"
                >
                <span>Asset Idle</span>
                  <!-- <img
                    matTooltip="Asset Idle"
                    style="height: 10px; width: 10px"
                    src="./assets/images/red.png"
                    [matTooltipClass]="'tooltip1'"
                  /> -->
                  <div style="background-color: #dbccbf; width: 10px; height: 10px; border-radius: 50%;"></div>
              </span>
                <span
                *ngIf="powertrain.overall_live_status==1"
                class="seen"
                >
                <span>Asset Running</span>
                  <!-- <img
                    matTooltip="Asset Running"
                    style="height: 10px; width: 10px"
                    src="./assets/images/green.png"
                    [matTooltipClass]="'tooltip1'"
                  /> -->
                  <div style="background-color: #3fbddd; width: 10px; height: 10px; border-radius: 50%;"></div>
              </span>
              </div>

              <div class="mb-4 w-100" style="flex-grow: 1;" (click)="openFilteredPowertrainScreen(i)" *ngIf="powertrain.subsystem_type=='powertrain'">
                <div
                  class="cursor-move"
                  [ngStyle]="{
                    width: '100%',
                    height: '100%',
                    position:'relative'
                  }"
                >
                  <img [src]="powertrain.Image_path" id="images-{{i}}" class="w-100 h-100 img" />

                  <!-- class="sensor border rounded-2 center_flex" -->
                  <div
                    *ngFor="let sensor of powertrain.sensors"
                    class="new_sensor_style rounded-2"
                    [matTooltip]="showTooltip(sensor)"
                    [matTooltipClass]="'tooltip'"
                    [ngStyle]="{
                      top: sensor.yPercentage+'%',
                      left: sensor.xPercentage+'%',
                      position:'absolute',
                      'background-color': sensor.color
                    }"
                    [ngClass]="{
                       'pulsing-circle': sensor.color == 'red',
                        border_yellow: sensor.color == 'orange',
                        border_green: sensor.color == 'green',
                    }"
                  >
                    <div class="sensor_no">
                      <!-- {{ sensor.sensor_number == 0 ? "B" : sensor.sensor_number }} -->
                      <!-- {{ sensor.sensorMarker }} -->
                      {{ sensor.sensorDNames }}
                    </div>
                    <img
                      src="./assets/wifion.png"
                      class="sensor_wifi"
                      alt=""
                      *ngIf="[1,0].includes(sensor.asset_status)"
                      />
                    <img
                      src="./assets/wifioff.png"
                      class="sensor_wifi"
                      alt=""
                      *ngIf="[2].includes(sensor.asset_status)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="powertrain-card" cdkDrag *ngFor="let powertrain of filtered_piezo_asset_list;let i = index" [ngStyle]="{'background-color':powertrain.overall_health}" [class.redBlink]="powertrain.overall_health=='#f8d7da'">
              <div class="title">{{powertrain.subsystem_name}}</div>
              <div class="status-symbol">
                <span
                *ngIf="[0,2,'0','2'].includes(powertrain.overall_live_status)"
                class="seen"
                >
                <span>Asset Idle</span>
                  <div style="background-color: #dbccbf; width: 10px; height: 10px; border-radius: 50%;"></div>
              </span>
                <span
                *ngIf="powertrain.overall_live_status==1"
                class="seen"
                >
                <span>Asset Running</span>
                  <div style="background-color: #3fbddd; width: 10px; height: 10px; border-radius: 50%;"></div>
              </span>
              </div>

              <div class="mb-4 w-100" style="flex-grow: 1;" (click)="openPiezoAssetDetails(i)" *ngIf="powertrain.subsystem_type=='piezeo'">
                <div
                  class="cursor-move"
                  [ngStyle]="{
                    width: '100%',
                    height: '100%',
                    position:'relative'
                  }"
                >
                  <img [src]="powertrain.Image_path" id="images-{{i}}" class="w-100 h-100 img" />

                  <div
                    *ngFor="let sensor of powertrain.sensors"
                    class="new_sensor_style rounded-2"
                    [title]="showPiezoTooltip(sensor)"
                    [ngStyle]="{
                      top: sensor.yPercentage+'%',
                      left: sensor.xPercentage+'%',
                      position:'absolute',
                      'background-color': sensor.color
                    }"
                    [ngClass]="{
                       'pulsing-circle': sensor.color == 'red',
                        border_yellow: sensor.color == 'orange',
                        border_green: sensor.color == 'green',
                    }"
                  >
                    <div class="sensor_no">
                      {{ sensor.sensorDNames }}
                    </div>
                    <img
                      src="./assets/wifion.png"
                      class="sensor_wifi"
                      alt=""
                      *ngIf="[1,0].includes(sensor.asset_status)"
                      />
                    <img
                      src="./assets/wifioff.png"
                      class="sensor_wifi"
                      alt=""
                      *ngIf="[2].includes(sensor.asset_status)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="showEmptyError === ''; else showLoader"  [cdkDropListData]="powertrainList" cdkDropList cdkDropListOrientation="mixed" class="pt_container" (cdkDropListDropped)="dropPt($event)">
          <div class="powertrain-card"
          (click)="openPowertrainScreen(i)" cdkDrag *ngFor="let powertrain of powertrainList;let i = index" [ngStyle]="{'background-color':powertrain.overall_health,'width':powertrain.client_id==502?'50%':'30%'}" [class.redBlink]="powertrain.overall_health=='#f8d7da'">
            <div class="title">{{powertrain.subsystem_name}}</div>
            <div class="status-symbol">
              <span
              *ngIf="[0,2].includes(powertrain.overall_live_status)"
              class="seen"
              >
                <span>Asset Idle</span>
                <div style="background-color: #dbccbf; width: 10px; height: 10px; border-radius: 50%;"></div>
            </span>
              <span
              *ngIf="powertrain.overall_live_status==1"
              class="seen"
              >
              <span>Asset Running</span>
                <div style="background-color: #3fbddd; width: 10px; height: 10px; border-radius: 50%;"></div>
            </span>
            </div>

            <div class="mb-4 w-100" style="flex-grow: 1;" *ngIf="powertrain.subsystem_type=='powertrain'">
              <div
                class="cursor-move"
                [ngStyle]="{
                  width: '100%',
                  height: '100%',
                  position:'relative'
                }"
              >
                <img [src]="powertrain.Image_path" id="images-{{i}}" class="w-100 h-100 img" />
                <div
                  *ngFor="let sensor of powertrain.sensors"
                  class="new_sensor_style rounded-2"
                  [matTooltip]="showTooltip(sensor)"
                  [matTooltipClass]="'tooltip'"
                  [ngStyle]="{
                    top: sensor.yPercentage+'%',
                    left: sensor.xPercentage+'%',
                    position:'absolute',
                    'background-color': sensor.color
                  }"
                  [ngClass]="{
                     'pulsing-circle': sensor.color == 'red',
                      border_yellow: sensor.color == 'orange',
                      border_green: sensor.color == 'green'
                  }"
                >
                  <div class="sensor_no">
                    {{ sensor.sensorDNames }}
                  </div>
                  <img
                    src="./assets/wifion.png"
                    class="sensor_wifi"
                    alt=""
                    *ngIf="sensor.asset_status==1 || sensor.asset_status==0"
                    />
                    <img
                    src="./assets/wifioff.png"
                    class="sensor_wifi"
                    alt=""
                    *ngIf="sensor.asset_status ==2"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
          <!-- POWERTRAIN ROTATING ASSET DISABLED FOR NOW... -->
          <div class="mb-4 cursor-move border" style="position:relative" *ngFor="let powertrain of powertrainAssetList;let i = index" (click)="openPowertrainScreen(i)">
              <div class="" *ngFor="let asset of powertrain.device_position" style="position:absolute">
                <img [src]="asset.src" class="img" style="width: 200px; height: 100px;"/>
                <div
                  *ngFor="let sensor of asset.sensors"
                  class="sensor border rounded-2 center_flex shadow-lg"
                >
                  <div class="sensor_no">
                    {{ sensor.sensor_number == 0 ? "B" : sensor.sensor_number }}
                  </div>
                  <img
                    src="./assets/wifion.png"
                    width="16"
                    height="16"
                    alt=""
                    *ngIf="sensor.asset_status == 1"
                  />
                  <img
                    src="./assets/wifioff.png"
                    width="16"
                    height="16"
                    alt=""
                    *ngIf="sensor.asset_status != 1"
                  />
                </div>
              </div>
          </div>

        </div>
        <!-- <div class="no_result" *ngIf="showEmptyError !== '' && !showPowertrain"> -->
          <div class="assetLoader" *ngIf="(showEmptyError && !showPowertrain && rotatingAssetLoader); else checkAssets">
            <!-- <p style="
                font-size: 16px;
                color: #838383;
                text-align: center;
                padding: 30px;
              ">
              {{ showEmptyError }}
            </p> -->
            <div
              *ngFor="let width of randomWidths; let i = index"
              class="skeleton skeleton-asset"
              [ngStyle]="{'width.px': width, 'height.px': 209}"
            ></div>
          </div>
        <ng-template #checkAssets>
          <div *ngIf="rotatingAssetExists; else showNoAssetMessage">
          <div class="content_view" [ngClass]="{ 'cursor-pointer': onButtonClicked }" *ngIf="gridLayoutOn && !showPowertrain">
            <div class="row">
              <div class="col-md-12">
                <div class="boxes_outer" cdkDropListGroup style="margin-top: 40px;">
                  <ng-container *ngFor="let device of allDeviceSecondArray; let i = index">
                    <div class="box" [ngClass]="{ boxAfterClick: onButtonClicked }" cdkDropList [ngClass]="device.orientation === 'vertical' ? 'vertical-box' : 'horizontal-box'"
                      *ngIf="device.powertrain==0"
                      cdkDropListOrientation="horizontal" [cdkDropListData]="{ item: device, index: i }"
                      (cdkDropListDropped)="onDrop($event)" [class.redBlink]="
                        device.color == '#F8D7DA' && device.asset_status == 1 && device.out_of_service=='no'
                      " [style.background-color]="device.out_of_service=='yes'?'rgb(184 184 184)':device.color">
                      <div cdkDrag>
                        <!-- <div class="statusSymbol">
                          <span *ngIf="
                              device.asset_status === 0 ||
                              device.asset_status === 2
                            " class="seen">
                            <img matTooltip="Asset offline" style="height: 10px; width: 10px"
                              src="./assets/images/red.png" [matTooltipClass]="'tooltip1'" />
                          </span>
                          <span *ngIf="device.asset_status === 1" class="seen">
                            <img matTooltip="Asset online" style="height: 10px; width: 10px"
                              src="./assets/images/green.png" [matTooltipClass]="'tooltip1'" />
                          </span>
                        </div> -->
                        <div class="statusSymbol">
                          <span
                            *ngIf="
                              device.out_of_service =='yes'; else asset_status
                            "

                            class="seen"
                          >
                            <img
                              matTooltip="Asset out for service"
                              style="height: 10px; width: 10px"
                              src="./assets/images/yellow.png"
                              [matTooltipClass]="'tooltip1'"
                          /></span>
                          <ng-template #asset_status>
                            <span
                            *ngIf="device.overall_status == 0 || device.overall_status == 2"
                            class="seen"
                          >
                            <!-- <img
                              matTooltip="Asset Idle"
                              style="height: 10px; width: 10px"
                              src="./assets/images/red.png"
                              [matTooltipClass]="'tooltip1'"
                          /> -->
                          <div style="background-color: #cecece; width: 10px; height: 10px; border-radius: 50%;" matTooltip="Asset Idle"
                         [matTooltipClass]="'tooltip1'"></div>
                        </span>
                          </ng-template>

                          <span *ngIf="device.out_of_service=='yes'; else asset_status_green " class="seen">
                            <img
                              matTooltip="Asset out for service"
                              style="height: 10px; width: 10px"
                              src="./assets/images/yelllow.png"
                              [matTooltipClass]="'tooltip1'"
                            />
                          </span>
                          <ng-template #asset_status_green>
                            <span *ngIf="device.overall_status == 1" class="seen">
                              <!-- <img
                                matTooltip="Asset Running"
                                style="height: 10px; width: 10px"
                                src="./assets/images/green.png"
                                [matTooltipClass]="'tooltip1'"
                              /> -->
                              <div style="background-color: #3fbddd; width: 10px; height: 10px; border-radius: 50%;" matTooltip="Asset Running"
                              [matTooltipClass]="'tooltip1'"></div>
                            </span>
                          </ng-template>
                        </div>
                        <div class="data">
                          <h4 class="name bl_color">{{ device.name }}</h4>
                          <!-- <p class="num smoke_color">{{device?.motor_serial_no || 'N/A'}}</p> -->
                          <!-- <p class="num" *ngFor="let sensor of device.connected_sensors"> -->
                          <p class="num" *ngFor="
                              let sensor of device.connected_sensors;
                              let i = index
                            ">
                            {{
                            i === 0
                            ? sensor.motor_serial_no
                            : ", " + sensor.motor_serial_no.substr(-4)
                            }}
                          </p>
                          <!-- <p class="num" *ngFor="let sensor of device.connected_sensors.slice(1)">
                                   {{device.motor_serial_no}}
                                   {{", "+ sensor.motor_serial_no.substr(-4)}}
                                   </p> -->
                        </div>
                        <div *ngIf="device.new !== undefined" class="{{ device.asset_type_s }} rotatableBox motorView EditView {{
                            device.asset_type
                          }}"[ngClass]="device.orientation === 'vertical' ? 'vertical' : 'horizontal'">
                          <div class="motor left {{ device.asset_type }}">
                            <span class="left" *ngFor="let sensor of device.connected_sensors"><button *ngIf="
                                  sensor.parent === 'primary' &&
                                  sensor.sensor === 'nde'
                                " (click)="openDetailScreen(sensor, device)" matTooltip="{{ sensor.motor_serial_no }}"
                                [style.background-color]="device.out_of_service=='yes'?'#fcda42': sensor.color" class="numBtn">
                                {{ sensor.sno }}
                                <span *ngIf="sensor.asset_status === 2"
                                  class="sprite_iconred wifiIcon wifi_redlabel"></span>
                                <span *ngIf="sensor.asset_status === 1 || sensor.asset_status === 0" class="sprite_icon wifiIcon wifi_ys"></span>
                                <!-- <span *ngIf="sensor.asset_status === 0"
                                  class="sprite_icon wifiIcon wifi_na"></span> -->
                                </button></span>
                            <span class="center" [style.left.px]="
                                device.asset_type === 'MOTOR' &&
                                device.imgS == 'null'
                                  ? -200
                                  : -25
                              " *ngFor="let sensor of device.connected_sensors"><button *ngIf="
                                  sensor.parent === 'primary' &&
                                  sensor.sensor === 'frame'
                                " (click)="openDetailScreen(sensor, device)" matTooltip="{{ sensor.motor_serial_no }}"
                                [style.background-color]="device.out_of_service=='yes'?'#fcda42': sensor.color" class="numBtn">
                                {{ sensor.sno }}
                                <span *ngIf="sensor.asset_status === 2"
                                  class="sprite_iconred wifiIcon wifi_redlabel"></span>
                                <span *ngIf="sensor.asset_status === 1 || sensor.asset_status === 0" class="sprite_icon wifiIcon wifi_ys"></span>
                                <!-- <span *ngIf="sensor.asset_status === 0"
                                  class="sprite_icon wifiIcon wifi_na"></span> -->
                                </button></span>
                            <span class="right" [style.right.px]="
                                device.asset_type === 'MOTOR' &&
                                device.imgS == 'null'
                                  ? 177
                                  : 25
                              " *ngFor="let sensor of device.connected_sensors"><button *ngIf="
                                  sensor.parent === 'primary' &&
                                  sensor.sensor === 'de'
                                " (click)="openDetailScreen(sensor, device)" matTooltip="{{ sensor.motor_serial_no }}"
                                [style.background-color]="device.out_of_service=='yes'?'#fcda42': sensor.color" class="numBtn">
                                {{ sensor.sno }}
                                <span *ngIf="sensor.asset_status === 2"
                                  class="sprite_iconred wifiIcon wifi_redlabel"></span>
                                <span *ngIf="sensor.asset_status === 1 || sensor.asset_status === 0" class="sprite_icon wifiIcon wifi_ys"></span>
                                <!-- <span *ngIf="sensor.asset_status === 0"
                                  class="sprite_icon wifiIcon wifi_na"></span> -->
                                </button></span>
                            <img src="{{ device.imgP }}" />
                            <img *ngIf="
                                (device.asset_type === 'MOTOR' ||
                                  device.asset_type === 'SYNCHRONOUS_MOTOR' ||
                                  device.asset_type === 'INDUCTION_MOTOR' ||
                                  device.asset_type === 'DC_MOTOR') &&
                                device.imgS == 'null'
                              " style="width: 40px; height: 40px" src="./assets/coupling.png" alt="" />
                            <div *ngIf="
                                (device.asset_type === 'MOTOR' ||
                                  device.asset_type === 'SYNCHRONOUS_MOTOR' ||
                                  device.asset_type === 'INDUCTION_MOTOR' ||
                                  device.asset_type === 'DC_MOTOR') &&
                                device.imgS == 'null'
                              " class="drivenEquip">
                              Driven Equipment
                            </div>
                          </div>
                          <div class=" motor right {{ device.asset_type_s }}" *ngIf="device.asset_type_s">
                            <span class="left coupleLeft" *ngFor="let sensor of device.connected_sensors">
                              <button *ngIf="
                                  sensor.parent === 'primary' &&
                                  sensor.sensor === 'couple'
                                " (click)="openDetailScreen(sensor, device)" matTooltip="{{ sensor.motor_serial_no }}"
                                [style.background-color]="device.out_of_service=='yes'?'#fcda42': sensor.color" class="numBtn">
                                {{ sensor.sno }}
                                <!-- <span class="wifiIcon"><i class="fa fa-wifi"></i></span> -->
                                <span *ngIf="sensor.asset_status === 2"
                                  class="sprite_iconred wifiIcon wifi_redlabel"></span>
                                <span *ngIf="sensor.asset_status === 1 || sensor.asset_status === 0" class="sprite_icon wifiIcon wifi_ys"></span>
                                <!-- <span *ngIf="sensor.asset_status === 0" class="sprite_icon wifiIcon wifi_na"></span> -->
                              </button>
                            </span>
                            <!-- <span class="left" *ngFor="let sensor of device.connected_sensors"><button
                                      *ngIf="sensor.parent === 'secondry' && sensor.sensor === 'de'"
                                      (click)="openDetailScreen(sensor, device)"
                                      [style.background-color]="sensor.color">{{SC}}</button></span> -->
                            <span class="left" *ngFor="let sensor of device.connected_sensors"><button *ngIf="
                                  sensor.parent === 'secondry' &&
                                  sensor.sensor === 'de'
                                " (click)="openDetailScreen(sensor, device)" matTooltip="{{ sensor.motor_serial_no }}"
                                [style.background-color]="device.out_of_service=='yes'?'#fcda42': sensor.color" class="numBtn">
                                {{ sensor.sno }}
                                <span *ngIf="sensor.asset_status === 2"
                                  class="sprite_iconred wifiIcon wifi_redlabel"></span>
                                <span *ngIf="sensor.asset_status === 1 || sensor.asset_status === 0" class="sprite_icon wifiIcon wifi_ys"></span>
                                <!-- <span *ngIf="sensor.asset_status === 0"
                                  class="sprite_icon wifiIcon wifi_na"></span> -->
                                </button></span>
                            <span class="center" *ngFor="let sensor of device.connected_sensors"><button *ngIf="
                                  sensor.parent === 'secondry' &&
                                  sensor.sensor === 'frame'
                                " (click)="openDetailScreen(sensor, device)" matTooltip="{{ sensor.motor_serial_no }}"
                                [style.background-color]="device.out_of_service=='yes'?'#fcda42': sensor.color" class="numBtn">
                                {{ sensor.sno }}
                                <span *ngIf="sensor.asset_status === 2"
                                  class="sprite_iconred wifiIcon wifi_redlabel"></span>
                                <span *ngIf="sensor.asset_status === 1 || sensor.asset_status === 0" class="sprite_icon wifiIcon wifi_ys"></span>
                                <!-- <span *ngIf="sensor.asset_status === 0"
                                  class="sprite_icon wifiIcon wifi_na"></span> -->
                                </button></span>
                            <span class="right" *ngFor="let sensor of device.connected_sensors"><button *ngIf="
                                  sensor.parent === 'secondry' &&
                                  sensor.sensor === 'nde'
                                " (click)="openDetailScreen(sensor, device)" matTooltip="{{ sensor.motor_serial_no }}"
                                [style.background-color]="device.out_of_service=='yes'?'#fcda42': sensor.color" class="numBtn">
                                {{ sensor.sno }}
                                <span *ngIf="sensor.asset_status === 2"
                                  class="sprite_iconred wifiIcon wifi_redlabel"></span>
                                <span *ngIf="sensor.asset_status === 1 || sensor.asset_status === 0" class="sprite_icon wifiIcon wifi_ys"></span>
                                <!-- <span *ngIf="sensor.asset_status === 0"
                                  class="sprite_icon wifiIcon wifi_na"></span> -->
                                </button></span>
                            <img src="{{ device.imgS }}" />
                          </div>
                        </div>
                        <div class="motorView" *ngIf="device.template_id === '1'">
                          <div class="motor left {{ device.asset_type }}">
                            <span class="center_single" *ngFor="let sensor of device.connected_sensors"><button
                                *ngIf="sensor.device_sno === 1" (click)="openDetailScreen(sensor, device)"
                                [style.background-color]="device.out_of_service=='yes'?'#fcda42': sensor.color">
                                {{ sensor.device_sno }}
                              </button></span>
                            <img *ngIf="device.asset_type === 'MOTOR'" src="./assets/motor_n.png" />
                            <img *ngIf="device.asset_type === 'GEAR'" src="./assets/gearbox.png" />
                            <img *ngIf="device.asset_type === 'PUMP'" src="./assets/pump.png" />
                            <img *ngIf="device.asset_type === 'FAN_BLOWER'" src="./assets/fan.png" />
                            <img *ngIf="device.asset_type === 'JOURNAL_BEARING'" src="./assets/bearing2.png" />
                            <img *ngIf="device.asset_type === 'COMPRESSOR'" src="./assets/compressor.png" />
                          </div>
                        </div>
                        <div class="motorView" *ngIf="device.template_id === '4'">
                          <div class="motor left {{ device.asset_type }}">
                            <span class="left" *ngFor="let sensor of device.connected_sensors"><button
                                *ngIf="sensor.device_sno === 2" (click)="openDetailScreen(sensor, device)"
                                [style.background-color]="device.out_of_service=='yes'?'#fcda42': sensor.color">
                                {{ sensor.device_sno }}
                              </button></span>
                            <span class="center" *ngFor="let sensor of device.connected_sensors"><button
                                *ngIf="sensor.device_sno === 1" (click)="openDetailScreen(sensor, device)"
                                [style.background-color]="device.out_of_service=='yes'?'#fcda42': sensor.color">
                                {{ sensor.device_sno }}
                              </button></span>
                            <span class="right" *ngFor="let sensor of device.connected_sensors"><button
                                *ngIf="sensor.device_sno === 3" (click)="openDetailScreen(sensor, device)"
                                [style.background-color]="device.out_of_service=='yes'?'#fcda42': sensor.color">
                                {{ sensor.device_sno }}
                              </button></span>
                            <img *ngIf="device.asset_type === 'MOTOR'" src="./assets/motor_n.png" />
                            <img *ngIf="device.asset_type === 'GEAR'" src="./assets/gearbox.png" />
                            <img *ngIf="device.asset_type === 'PUMP'" src="./assets/pump.png" />
                            <img *ngIf="device.asset_type === 'FAN_BLOWER'" src="./assets/fan.png" />
                            <img *ngIf="device.asset_type === 'JOURNAL_BEARING'" src="./assets/bearing2.png" />
                            <img *ngIf="device.asset_type === 'COMPRESSOR'" src="./assets/compressor.png" />
                          </div>
                        </div>
                        <!-- <div *ngIf="device.bearing_issue==true" class="" style="
                        display: flex;
                        align-items: center;
                        justify-content: end;
                    ">
                          <div class="" style="
                          width: 60px;
                          height: 42px;
                          padding: 2px;
                          border-radius: 10px;
                      "
                       [ngStyle]="{'background-color': device.bearing_issue_color}"
                      >
                            <img src="./assets/bearing.png" alt="" style="
                            width: 100%;
                            object-fit: contain;
                            height: 100%;
                        ">
                          </div>
                        </div> -->
                        <!-- <div class="motorView {{device.asset_type}}" *ngIf="device.template_id === '5'">
                                <div class="motor left">
                                  <span class="left_t6_de" *ngFor="let sensor of device.connected_sensors"><button
                                      *ngIf="sensor.device_sno === 2" (click)="openDetailScreen(sensor, device)"
                                      [style.background-color]="sensor.color">{{sensor.device_sno}}</button></span>
                                  <span class="center" *ngFor="let sensor of device.connected_sensors"><button
                                      *ngIf="sensor.device_sno === 1" (click)="openDetailScreen(sensor, device)"
                                      [style.background-color]="sensor.color">{{sensor.device_sno}}</button></span>
                                  <span class="right_t6_nde" *ngFor="let sensor of device.connected_sensors"><button
                                      *ngIf="sensor.device_sno === 3" (click)="openDetailScreen(sensor, device)"
                                      [style.background-color]="sensor.color">{{sensor.device_sno}}</button></span>
                                  <img src="./assets/motor_n.png">

                                  <img *ngIf="device.asset_type === 'GEAR'" src="./assets/gearbox.png">
                                  <img *ngIf="device.asset_type === 'PUMP'" src="./assets/pump.png">
                                  <img *ngIf="device.asset_type === 'FAN_BLOWER'" src="./assets/fan.png">
                                  <img *ngIf="device.asset_type === 'JOURNAL_BEARING'" src="./assets/bearing2.png">
                                  <img *ngIf="device.asset_type === 'COMPRESSOR'" src="./assets/compressor.png">
                                </div>
                                <div class="motor right {{device.asset_type}}">

                                  <img *ngIf="device.asset_type === 'MOTOR'" src="./assets/motor_n.png">
                                  <img *ngIf="device.asset_type === 'GEAR'" src="./assets/gearbox.png">
                                  <img *ngIf="device.asset_type === 'PUMP'" src="./assets/pump.png">
                                  <img *ngIf="device.asset_type === 'FAN_BLOWER'" src="./assets/fan.png">
                                  <img *ngIf="device.asset_type === 'JOURNAL_BEARING'" src="./assets/bearing2.png">
                                  <img *ngIf="device.asset_type === 'COMPRESSOR'" src="./assets/compressor.png">
                                </div>
                                </div> -->
                        <!-- <div class="motorView {{device.asset_type}}" *ngIf="device.template_id === '7'">
                                <div class="motor left">
                                  <span class="left" *ngFor="let sensor of device.connected_sensors"><button
                                      *ngIf="sensor.device_sno === 2" (click)="openDetailScreen(sensor, device)"
                                      [style.background-color]="sensor.color">{{sensor.device_sno}}</button></span>
                                  <span class="center" *ngFor="let sensor of device.connected_sensors"><button
                                      *ngIf="sensor.device_sno === 1" (click)="openDetailScreen(sensor, device)"
                                      [style.background-color]="sensor.color">{{sensor.device_sno}}</button></span>
                                  <span class="right" *ngFor="let sensor of device.connected_sensors"><button
                                      *ngIf="sensor.device_sno === 3" (click)="openDetailScreen(sensor, device)"
                                      [style.background-color]="sensor.color">{{sensor.device_sno}}</button></span>
                                  <img src="./assets/motor_n.png">
                                </div>
                                <div class="motor right {{device.asset_type}}">

                                  <img *ngIf="device.asset_type === 'MOTOR'" src="./assets/motor_n.png">
                                  <img *ngIf="device.asset_type === 'GEAR'" src="./assets/gearbox.png">
                                  <img *ngIf="device.asset_type === 'PUMP'" src="./assets/pump.png">
                                  <img *ngIf="device.asset_type === 'FAN_BLOWER'" src="./assets/fan.png">
                                  <img *ngIf="device.asset_type === 'JOURNAL_BEARING'" src="./assets/bearing2.png">
                                  <img *ngIf="device.asset_type === 'COMPRESSOR'" src="./assets/compressor.png">
                                  <span class="left" *ngFor="let sensor of device.connected_sensors"><button
                                      *ngIf="sensor.device_sno === 4" (click)="openDetailScreen(sensor, device)"
                                      [style.background-color]="sensor.color">{{sensor.device_sno}}</button></span>
                                  <span class="right" *ngFor="let sensor of device.connected_sensors"><button
                                      *ngIf="sensor.device_sno === 5" (click)="openDetailScreen(sensor, device)"
                                      [style.background-color]="sensor.color">{{sensor.device_sno}}</button></span>
                                </div>
                                </div> -->
                                <div class="out_of_service" *ngIf="device.out_of_service=='yes'">
                                  <div class="" style="font-weight: 700;">Out for service</div>
                                </div>
                        <div class="icons">
                          <!-- <div *ngIf="device.connectivity_type === 'wifi'">
                                   <span *ngIf="device.asset_status === 2" class="sprite_icon wifi_red"></span>
                                   <span *ngIf="device.asset_status === 1" class="sprite_icon wifi_black"></span>
                                   <span *ngIf="device.asset_status === 0" class="sprite_icon wifi_black"></span>
                                   </div> -->
                          <!-- <img style="    height: 25px;
                                   width: 25px;" *ngIf="device.asset_type === 'MOTOR'" src="./assets/motor.png">
                                    <img style="    height: 25px;
                                   width: 25px;" *ngIf="device.asset_type === 'GEAR'" src="./assets/engine.png">
                                    <img style="    height: 25px;
                                   width: 25px;" *ngIf="device.asset_type === 'PUMP'" src="./assets/pump.png">
                                    <img style="    height: 25px;
                                          width: 25px;" *ngIf="device.asset_type === 'FAN_BLOWER'" src="./assets/fan.png">
                                    <img style="    height: 25px;
                                     width: 25px;" *ngIf="device.asset_type === 'JOURNAL_BEARING'" src="./assets/bearing2.png">
                                    <img style="    height: 25px;
                                       width: 25px;" *ngIf="device.asset_type === 'COMPRESSOR'" src="./assets/compressor.png"> -->
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="[1, 2, 4, 6, 20, 50, 100, 200]"
              [hidePageSize]="false" [showFirstLastButtons]="false" [length]="totalSize" [pageIndex]="pageIndex"
              (page)="pageEvent = handlePage($event)">
            </mat-paginator>
          </div>
        </div>
        </ng-template>
        <ng-template #showNoAssetMessage>
          <p style="
              font-size: 16px;
              color: #838383;
              text-align: center;
              padding: 30px;
              padding-top: 80px;
            ">
            {{ showEmptyError }}
          </p>
        </ng-template>
        <div class="no_result" *ngIf="showPowertrain && !powertrainLoader && powertrainList.length == 0 && filtered_piezo_asset_list.length==0 && !piezo_asset_loader">
          <p style="
              font-size: 16px;
              color: #838383;
              text-align: center;
              padding: 30px;
            ">
              No powertrains Available
          </p>
        </div>
<div style="padding-top: 40px !important;"><app-list-view-rotating-asset  *ngIf="listLayoutOn && !showPowerTrain" [allDeviceSecondArray]="allDeviceSecondArray" [extendedChildList]="extendedChildList"></app-list-view-rotating-asset></div>
        <!-- ------Listing view------- -->


      </ng-template>
    </li>

    <li [ngbNavItem]="'tab-2'" *ngIf="!production && tabID_2 ">
      <a ngbNavLink>Transformers <span>({{transformerCount}})</span></a>
      <ng-template ngbNavContent>
        <mat-toolbar class="top_headerbar">
          <div class="left" [ngClass]="{ show: shouldShow, hide: !shouldShow }">
            <span *ngIf="hideItemsFromAssets" class="custom_select_outer">
              <select class="custom_select form-control width_180" #mySelect (change)="onSiteSelected(mySelect.value)"
                *ngIf="!showFilter">
                <option value="0">All Sites</option>
                <option value="{{ site.id }}" *ngFor="let site of sitesList">
                  {{ site.name }}
                </option>
              </select>
            </span>
            <span *ngIf="hideItemsFromAssets" class="custom_select_outer">
              <select class="custom_select form-control width_180" #groupSelect
                (change)="onGroupSelected(groupSelect.value)" *ngIf="!showFilter">
                <option value="0">All Applications</option>
                <option value="{{ group.id }}" *ngFor="let group of groupList; let idx = index">
                  {{ group.name }}
                </option>
              </select>
            </span>
            <span class="custom_select_outer">
              <select class="custom_select form-control width_180" [value]="assetsFilter" #assetsSelect
                (change)="viewAssetsList(assetsSelect.value)">
                <option value="ALL">All Assets</option>
                <option value="OFFLINE">Offline</option>
                <option value="HEALTHY">Healthy</option>
                <option value="UNHEALTHY">Unsatisfactory</option>
                <option value="ERROR">Unacceptable</option>
              </select>
            </span>
          </div>
          <!--serch and list button code-->
          <!-- <div *ngIf="adminClinetLogin" class="right">
            <div *ngIf="hideItemsFromAssets" class="all_action_btns">
              <div class="custom_search width_200">
                <span class="sprite_icon search"></span>
                <input type="text" class="form-control" placeholder="Serial Number" [(ngModel)]="term"
                  (input)="searchData($event.target.value)">
              </div>

              <div class="btn-group view_btn_group">
                <button type="button" class="btn default_btn" (click)="listLayout()">
                  <span class="sprite_icon grid_grey" [ngClass]="{'grid_blue' : gridLayoutOn}"></span>
                </button>
                <button type="button" class="btn default_btn" (click)="gridLayout()">
                  <span [ngClass]="{'list_blue' : listLayoutOn}" class="sprite_icon list_grey"></span>
                </button>
              </div>
            </div>
          </div> -->
        </mat-toolbar>
        <app-transformers [tab3]="tabID_3" [tab4]="tabID_4"></app-transformers>
      </ng-template>
    </li>

    <li [ngbNavItem]="'tab-3'"*ngIf="tabID_3 ">
      <a ngbNavLink>Energy Meters <span>({{energymeterCount}})</span></a>
      <ng-template ngbNavContent>
        <mat-toolbar class="top_headerbar">
          <div class="left" [ngClass]="{ show: shouldShow, hide: !shouldShow }">
            <span *ngIf="hideItemsFromAssets" class="custom_select_outer">
              <select class="custom_select form-control width_180"  [(ngModel)]="siteid"  #mySelect (change)="getEnergymeterAllSitesByID(mySelect.value)"
                *ngIf="!showFilter">
                <option value="0">All Sites</option>
                <option value="{{ site.id }}" *ngFor="let site of energymeterSitesList">
                  {{ site.name }}
                </option>
              </select>
            </span>
            <span *ngIf="hideItemsFromAssets" class="custom_select_outer">
              <select class="custom_select form-control width_180" [(ngModel)]="applicationid" #groupSelect
                (change)="getEnergymeterAllApplicationsByID(groupSelect.value)" *ngIf="!showFilter">
                <option value="0">All Applications</option>
                <option value="{{ group.id }}" *ngFor="let group of EnergymetergroupList; let idx = index">
                  {{ group.name }}
                </option>
              </select>
            </span>
            <span class="custom_select_outer">
              <select class="custom_select form-control width_180" #groupSelect
                (change)="getSpecificEnergymeterByID(groupSelect.value)" *ngIf="!showFilter">
                <option value="0">All Energymeters</option>
                <option value="{{ group.generic_asset_id }}" *ngFor="let group of energymeterApplicationList; let idx = index">
                  {{ group.name }}
                </option>
              </select>
            </span>

            <!-- <div class="em-radio-btn" *ngIf="EnergymeterAllDeviceSecondArray.length">
              <div class="radio-container w-90">
                <label>
                  <input type="radio" name="range" [(ngModel)]="selectedRange" value="year" (change)="onRangeChange(this.EnergymeterAllDeviceSecondArray)" checked="checked"> This Year
                </label>
              </div>
              <div class="radio-container">
                <label>
                  <input type="radio" name="range" [(ngModel)]="selectedRange" value="month" (change)="onRangeChange(this.EnergymeterAllDeviceSecondArray)"> This Month
                </label>
              </div>
              <div class="radio-container">
                <label>
                  <input type="radio" name="range" [(ngModel)]="selectedRange" value="week" (change)="onRangeChange(this.EnergymeterAllDeviceSecondArray)"> This Week
                </label>
              </div>
              <div class="radio-container">
                <label>
                  <input type="radio" name="range" [(ngModel)]="selectedRange" value="today" (change)="onRangeChange(this.EnergymeterAllDeviceSecondArray)"> Today
                </label>
              </div>
            </div> -->

          </div>
          <div class="tab_right" *ngIf="legendKey">
            <div class="legendbox legendBoxTop" style="margin-right: 10px;">
              <!-- <button *ngIf="hideaddsubsystem" mat-raised-button color="primary" (click)="DefineAssets()">
                <span class="sprite_icon plus_white"></span>
                <span><b>Add Sub-System</b></span>
              </button> -->
              <!-- <div style="background-color: #999999"></div>
              <strong>Offline</strong>
              <div style="background-color: #72ff13"></div>
              <strong>Healthy</strong>
              <div style="background-color: #faa700"></div>
              <strong>Unsatisfactory</strong>
              <div style="background-color: #fcda42"></div>
              <strong>Out for service</strong> -->
            </div>
          </div>
          <!-- <div style="display: flex; justify-content: end; width: 36%;" *ngIf="EnergymeterAllDeviceSecondArray.length">
            Enterprise&nbsp;&nbsp;<mat-slide-toggle [(ngModel)]="showStat" color="primary"  (change)="onToggleChange($event)"></mat-slide-toggle>&nbsp;&nbsp;Meters
          </div> -->
        </mat-toolbar>
        <div *ngIf="!showStat && EnergymeterAllDeviceSecondArray.length">
          <!-- start statistics -->
          <div class="grid-container">
            <div class="grid-item">
              <div class="inside-first-row">
                <div><img class="icon-meter" src="./assets/images/energy-meter.png"></div>
                <!-- image icon will go here -->
                <div>Total Meters</div>
                <div class="first-row-data">
                  <div *ngIf="loading">
                    <img src="/assets/chart_loader.gif" alt="Loading...">
                  </div>
                  <div *ngIf="!loading">
                      <!--{{YTDCost.YTDCurrency}} {{ getTotalYTDCost(this.EnergymeterAllDeviceSecondArray) | number:'1.2-2' }}-->
                      {{EnergymeterAllDeviceSecondArray.length || 0}}
                  </div>

                </div>

              </div>
            </div>
            <div class="grid-item">
              <div class="inside-first-row">
                <div><img style="top: -8px;" class="icon-meter" src="/assets/images/dollar.png"></div>
                <!-- image icon will go here -->
                <div>Actual Cost</div>
                <div class="first-row-data">
                  <div *ngIf="loading">
                    <img src="/assets/chart_loader.gif" alt="Loading...">
                  </div>
                  <div *ngIf="!loading">
                      <!--{{YTDCost.YTDCurrency}} {{ getTotalYTDCost(this.EnergymeterAllDeviceSecondArray) | number:'1.2-2' }}-->
                      {{YTDCost.YTDCurrency}} {{mainScreenYTDCost.YTDCost | number:'1.2-2'}}
                  </div>

                </div>

              </div>
            </div>

            <div class="grid-item">
              <div class="inside-first-row">
                <div><img class="icon-meter" src="/assets/images/co2.png"></div>
                <!-- image icon will go here  -->
                <div>Actual CO2</div>
                <div class="first-row-data">
                  <div *ngIf="loading">
                    <img src="/assets/chart_loader.gif" alt="Loading...">
                  </div>
                  <div *ngIf="!loading">
                      <!--{{ getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray) | number:'1.2-2' }}-->
                     {{mainScreenYTDCarbonFootprintCost.YTDCarbonFootprintCost | number:'1.2-2'}} Tons
                  </div>
                </div>

              </div>
            </div>

            <div class="grid-item">
              <div class="inside-first-row">
                <div><img class="icon-meter" src="/assets/images/net.png"></div>
                <!-- image icon will go here  -->
                <div>Inst. Pow. (KW)</div>
                <div class="first-row-data">
                  <div *ngIf="loading">
                    <img src="/assets/chart_loader.gif" alt="Loading...">
                  </div>
                  <div *ngIf="!loading">
                    <!--{{ getTotalPFCost(this.EnergymeterAllDeviceSecondArray) | number:'1.2-2' }}-->
                    <!-- {{mainScreenPFCost.PFCost | number:'1.2-2'}} {{this.mainScreenPFCost.PFCount}} -->
                    <!-- {{ (mainScreenPFCost.PFCost / mainScreenPFCost.PFCount) | number:'1.2-2' }} -->
                    <span *ngIf="mainScreenPDCost.PDCount!=0; else validPdCount">{{(mainScreenPDCost?.peak_demand / mainScreenPDCost?.PDCount)
                      ?? 'N/A' | number:'1.2-2' }}</span>
                      <ng-template #validPdCount>
                        {{
                           'N/A'
                        }}
                      </ng-template>
                  </div>
                </div>

              </div>
            </div>

            <div class="grid-item">
              <div class="inside-first-row">
                <div><img class="icon-meter" src="/assets/images/circle.png"></div>
                <!-- image icon will go here  -->
                <div>Overall Power Factor</div>
                <div class="first-row-data">
                  <div *ngIf="loading">
                    <img src="/assets/chart_loader.gif" alt="Loading...">
                  </div>
                  <div *ngIf="!loading">
                    <!--{{ getTotalPFCost(this.EnergymeterAllDeviceSecondArray) | number:'1.2-2' }}-->
                    <!-- {{mainScreenPFCost.PFCost | number:'1.2-2'}} {{this.mainScreenPFCost.PFCount}} -->
                    <!-- {{ (mainScreenPFCost.PFCost / mainScreenPFCost.PFCount) | number:'1.2-2' }} -->
                    <span *ngIf="mainScreenPFCost.PFCount!=0; else validPFCount">{{(mainScreenPFCost?.PFCost / mainScreenPFCost?.PFCount)
                      ?? 'N/A' | number:'1.2-2' }}</span>
                      <ng-template #validPFCount>
                        {{
                           'N/A'
                        }}
                      </ng-template>
                  </div>

                </div>
                <!-- data value  will go here otal  -->
              </div>
            </div>

            <div class="grid-item special-grid-item1" >
              <div class="inside-first-row">
                <div><img class="icon-meter" src="/assets/images/cost.png"></div>
                <!-- image icon will go here  -->
                <div>
                  Total Monetary Savings attributed to Energy Cost,CO2
                  Reductions
                </div>
                <div class="first-row-data">N/A</div>
                <!-- data value  will go here -->
              </div>
            </div>

            <div class="grid-item special-grid-item6 inside-2nd-3rd-row">
              <div class="title-meter">Energy Cost</div>
              <div>Actual Cost</div>
              <div class="data-show-divs second-row-data">
                <div *ngIf="loading">
                  <img src="/assets/chart_loader.gif" alt="Loading...">
                </div>
                <div *ngIf="!loading">
                  <!--{{YTDCost.YTDCurrency}} {{ getTotalYTDCost(this.EnergymeterAllDeviceSecondArray) | number:'1.2-2' }}-->
                  {{YTDCost.YTDCurrency}} {{mainScreenYTDCost.YTDCost | number:'1.2-2'}}
                </div>
              </div>
              <!-- <div>Predicted YTD Cost</div>
              <div class="data-show-divs second-row-data">N/A</div>
              <div>Predicted YE cost</div>
              <div class="data-show-divs second-row-data">N/A</div> -->
            </div>

            <div class="grid-item special-grid-item7 inside-2nd-3rd-row">
              <div class="title-meter">CO2 Foot-print</div>
              <div>Actual CO2</div>
              <div class="data-show-divs second-row-data">
                <div *ngIf="loading">
                  <img src="/assets/chart_loader.gif" alt="Loading...">
                </div>
                <div *ngIf="!loading">
                  <!--{{ getTotalYTDCarbonFootprintCost(this.EnergymeterAllDeviceSecondArray) | number:'1.2-2' }} Tons-->
                  {{mainScreenYTDCarbonFootprintCost.YTDCarbonFootprintCost | number:'1.2-2'}} Tons
                </div>
              </div>
              <!-- <div>Predicted YTD Co2</div>
              <div class="data-show-divs second-row-data">N/A</div>
              <div>Predicted Total YTD CO2</div>
              <div class="data-show-divs second-row-data">N/A</div> -->
            </div>
            <!-- This element spans the first two columns -->
            <div class="grid-item special-grid-item8" style="grid-column-end: span 2;">
              <div id="mapContainer" style="height: 450px !important">
                <app-energymeter-map [allClients]="allPointerFilterData" [sites]="sitesList"></app-energymeter-map>
              </div>
            </div>

            <div class="grid-item special-grid-item4 inside-2nd-3rd-row">
              <div class="title-meter">Power Events</div>
              <div>Voltage Events</div>
              <div class="data-show-divs second-row-data">N/A</div>
              <div>Overall Power Factor</div>
              <div class="data-show-divs second-row-data">

                <div *ngIf="loading">
                  <img src="/assets/chart_loader.gif" alt="Loading...">
                </div>
                <div *ngIf="!loading">
                  <!--{{ getTotalPFCost(this.EnergymeterAllDeviceSecondArray) | number:'1.2-2' }}-->
                  {{ (mainScreenPFCost.PFCost / mainScreenPFCost.PFCount) | number:'1.2-2' }}
                </div>
              </div>
              <div>Power Factor Dips</div>
              <div class="data-show-divs second-row-data">N/A</div>
              <!-- <div>Predicted Cumulative Events</div>
              <div class="data-show-divs second-row-data">N/A</div> -->
            </div>
            <!-- This element spans the first two columns -->
            <div class="grid-item special-grid-item4 inside-2nd-3rd-row">
              <div class="title-meter">Instantaneous Power</div>
              <div>Instantaneous Power (KW)</div>
              <div class="data-show-divs second-row-data">N/A</div>
              <div>Instantaneous Power (KVA)</div>
              <div class="data-show-divs second-row-data">N/A</div>
              <!-- <div>Curruntly Predicted Peak</div>
              <div class="data-show-divs second-row-data">N/A</div> -->
            </div>
          </div>

          <!-- end code of statistics -->
        </div>
        <div style="display: flex; align-items: center; justify-content: center; margin-top:100px" *ngIf="loadingService==true; else dataContent">
          <ng-container>
            <div class="spinner-container charts-loader">
              <div
                class="spinner-border text-primary"
                role="status"
              ></div>
            </div>
          </ng-container>
        </div>
        <ng-template #dataContent>
          <div *ngIf="showStat && EnergymeterAllDeviceSecondArray.length && !meterViewloader">
            <!-- Meters content goes here -->
             <div class="row col-md-12">
              <div class="transformerList" style="padding-top: 50px;">
              <div class="col-md-3 transformerSingle goodHealth" *ngFor="let energymeterData of EnergymeterAllDeviceSecondArray ;let index = index">


                <div class="data">
                  <h4 class="name bl_color" (click)="energyMeterDashboard(energymeterData.generic_asset_id,energymeterData.country_id,energymeterData.state_id, index,energymeterData.ofs,energymeterData.subsystemId)" style="cursor: pointer;">{{energymeterData.name}}</h4>
                  <p class="num"> {{energymeterData.mac_address}}</p>
                  <!-- <div class="transformerStatus"><img src="assets/images/green.png" style="width:9px;" /></div> -->
                </div>

                <!-- ***************** Edit/Delete Sub Menu three bullet Start HERE-->
                <div class="edit-delete-container"
                style="position: absolute; top: 5px; right: 10px; display: inline-flex; align-items: center; gap: 3px;">

            <!-- Status Dot -->
            <span style="width: 10px;height: 20px;display: flex;align-items: center;margin-top: -4px;"> <span  [ngClass]="energymeterData.asset_status == 1 && energymeterData.ofs==0 ? 'online' :energymeterData.asset_status == 0 && energymeterData.ofs==0? 'offline':'out_for_service_dot'"
              style="width: 10px !important; height: 10px; border-radius: 50%; display: inline-block;">
            </span></span>


            <!-- WiFi Button -->

              <mat-icon [ngStyle]="{ 'color': energymeterData.connection_status == 1 && energymeterData.ofs == 0 ? 'inherit' : energymeterData.connection_status == 0 && energymeterData.ofs == 0? 'red':'#fcda42' }">
                {{ energymeterData.connection_status == 1 && energymeterData.ofs == 0 ? 'wifi' : energymeterData.connection_status == 0 && energymeterData.ofs == 0 ? 'wifi_off':'' }}
              </mat-icon>



             <!-- More Options Button -->
             <button mat-icon-button style="width: 20px;" class="" [matMenuTriggerFor]="menu">
              <mat-icon style="position: absolute;top: 5px;margin-right: 0px !important;right: 6px;">more_vert</mat-icon>
            </button>



           </div>

           <mat-menu #menu="matMenu">
            <span style="display: grid;padding: 5px; gap: 5px;">
            <button mat-stroked-button color="primary"
              (click)="editEnergymeterGroup(energymeterData.generic_asset_id,energymeterData.site_id, energymeterData.application_id, energymeterData.generic_asset_id, userID, energymeterData.mac_address)">
              <mat-icon>info</mat-icon> Details
            </button>
            <button mat-stroked-button color="warn"
              (click)="showEnergymeterDeleteDialog(energymeterData.generic_asset_id,energymeterData.site_id, energymeterData.application_id, energymeterData.generic_asset_id, userID, energymeterData.subsystemId, energymeterData.clientEnergymeterRelationId)">
              <mat-icon>delete</mat-icon> Delete
            </button>
            </span>
          </mat-menu>
                <!-- ***************** Edit/Delete Sub Menu three bullet End HERE-->

                <div class="transformerNameIcon">
                      <div class="row m-0 p-0">

                        <div class="col-md-6 " >
                          <div class="grid-item">
                            <div class="inside-first-row">
                              <div class="title-meter">Cost ({{energymeterData.currency}})</div>
                              <div class="first-row-data">
                                <!-- {{ YTDCost[energymeterData.serialNumber]?.YTDCurrency }} {{ (YTDCost[energymeterData.serialNumber]?.YTDCost || "0.00") | number: '1.2-2' }} -->
                                 <!-- {{ (YTDCost[energymeterData.serialNumber]?.YTDCost || "0.00") | number: '1.2-2' }} -->
                                 <!-- {{YTDCost.YTDCurrency}} {{mainScreenYTDCost.YTDCost | number:'1.2-2'}} -->
                                  {{ energymeterData.cost  == "" || energymeterData.cost == null ? "0.00" : energymeterData.cost}}
                              </div>
                            </div>
                          </div>
                        </div>


                        <div class="col-md-6 ">
                          <div class="grid-item">
                            <div class="inside-first-row">
                              <div class="title-meter">C.F (Tons)</div>
                              <div class="first-row-data">
                                <!-- {{ (YTDCarbonFootprintCost[energymeterData.serialNumber]?.YTDCarbonFootprintCost || "0.00") | number: '1.2-2' }} -->
                                <!-- {{mainScreenYTDCarbonFootprintCost.YTDCarbonFootprintCost | number:'1.2-2'}} -->
                                {{energymeterData.co2cost == "" || energymeterData.co2cost == null ? "0.00" : energymeterData.co2cost }}
                              </div>
                            </div>
                          </div>
                        </div>


                        <div class="col-md-6  ">
                          <div class="grid-item">
                            <div class="inside-first-row">
                              <div class="title-meter">Inst. Pow. (KW)</div>
                              <div class="first-row-data">
                                <span *ngIf="energymeterData.pd!=0; else validPdCount">{{energymeterData.pd == "" || energymeterData.pd == null ? "0.00" : energymeterData.pd}}</span>
                                <ng-template #validPdCount>
                                     0.00
                                </ng-template>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="grid-item">
                            <div class="inside-first-row">
                              <div class="title-meter">Power Factor</div>
                              <div class="first-row-data">
                                <!-- {{ (PFCost[energymeterData.serialNumber]?.PFCost ?? '0.00') | number: '1.2-2' }} -->
                                <!-- <span *ngIf="mainScreenPFCost.PFCount!=0; else validPFCount">{{(mainScreenPFCost?.PFCost / mainScreenPFCost?.PFCount)
                                  ?? 'N/A' | number:'1.2-2' }}</span> -->
                                <span *ngIf="energymeterData.pfcost!=0; else validPFCount">{{energymeterData.pfcost == "" || energymeterData.pfcost == null ? "0.00" : energymeterData.pfcost}}</span>
                                  <ng-template #validPFCount>
                                       0.00
                                  </ng-template>
                              </div>

                            </div>
                          </div>
                        </div>

                      </div>

                </div>

              </div>
            </div>
             </div>
          </div>
          <div class="no_result" *ngIf="!EnergymeterAllDeviceSecondArray.length && loadingService==false">
            <p style="font-size: 16px; color: #838383;text-align: center; padding: 30px;"> No Energymeter added</p>
          </div>
        </ng-template>
      </ng-template>
    </li>

    <li [ngbNavItem]="'tab-4'" *ngIf="tabID_4 ">
      <a ngbNavLink>Eboiler <span>({{eboilerCount}})</span></a>
      <ng-template ngbNavContent>
        <app-boiler-room [tabName]="tabActice" [tab2]="tabID_2" [tab3]="tabID_3" [tab4]="tabID_4"></app-boiler-room>
      </ng-template>
    </li>

    <li [ngbNavItem]="'tab-5'" *ngIf="tabID_5">
      <a ngbNavLink>Cylinder <span>({{cylindersCount}})</span></a>
      <ng-template ngbNavContent>
        <app-cyclinder-listings [tabName]="tabActice" [tab1]="true" [tab2]="tabID_2" [tab3]="tabID_3" [tab4]="tabID_4" [tab7]="tabID_7"></app-cyclinder-listings>
      </ng-template>
    </li>
    <li [ngbNavItem]="'tab-7'" *ngIf="tabID_7">
      <a ngbNavLink>Oven System<span>({{oven_system_count}})</span></a>
      <ng-template ngbNavContent>
        <app-oven-device-list [tabName]="tabActice" [tab2]="tabID_2" [tab3]="tabID_3" [tab4]="tabID_4" [tab7]="tabID_7"></app-oven-device-list>
      </ng-template>
    </li>
    <li [ngbNavItem]="'tab-8'" *ngIf="tabID_8">
      <a ngbNavLink>Image Processing <span>({{oven_system_count}})</span></a>
      <ng-template ngbNavContent>
        <app-gauge-monitoring-dashboard></app-gauge-monitoring-dashboard>
      </ng-template>
    </li>
    @if (QAKey) {
      <li [ngbNavItem]="'tab-9'">
        <a ngbNavLink>Piezo Sensor <span>({{oven_system_count}})</span></a>
        <ng-template ngbNavContent>
          <!-- <app-piezo-sensor-dashboard></app-piezo-sensor-dashboard> -->
           <app-piezo-cards></app-piezo-cards>
        </ng-template>
      </li>
    }
  </ul>
  <div [ngbNavOutlet]="ctdTabset"></div>
</div>
